/**
 * <LiveClosedDialog> — le tuteur a clôturé le live (template).
 *
 * L'élève encore dans la salle l'apprend par un message, au lieu d'en être sorti en silence : « Ton
 * masteur a clôturé le live », et un seul bouton, pour sortir. Quand Sam a un quiz de fin de séance
 * à proposer, le message l'annonce : il fait le lien avec l'écran qui suit, hors du live. Sinon, il
 * félicite, et la sortie mène au rapport.
 *
 * Pas de croix : elle ferait la même chose que « Sortir du live », et le live est fini, il n'y a
 * pas de retour. La fenêtre ne se ferme pas autrement que par son bouton.
 */
import React from "react"
import { View } from "react-native"

import { Button } from "../../atoms/Buttons/Button"
import { Text } from "../../atoms/typography/Text"
import { Modal } from "../../molecules/Modal"

export type LiveClosedDialogProps = {
    visible: boolean
    /** La durée du quiz de fin de séance que Sam a préparé, en minutes. Absente : pas de quiz. */
    quizMinutes?: number
    /** « Sortir du live ». */
    onExit: () => void
    /** La sortie part. Défaut `false`. */
    exiting?: boolean
    testID?: string
}

/** La hauteur de la croix d'une modale (`<IconButton>`, 50 par défaut). */
const CLOSE_SLOT_HEIGHT = 50

const TEXTS = {
    title: "Ton masteur a clôturé le live",
    quiz: (minutes: number) => `Sam t'a préparé un quiz de ${minutes} minute${minutes > 1 ? "s" : ""} sur ta séance.`,
    noQuiz: "La séance est finie. Bravo pour ton travail !",
    exit: "Sortir du live",
}

export function LiveClosedDialog(props: LiveClosedDialogProps) {
    const { visible, quizMinutes, onExit, exiting = false, testID } = props
    return (
        <Modal
            visible={visible}
            onClose={onExit}
            title={TEXTS.title}
            // La place de la croix reste vide, à sa hauteur : l'en-tête garde son air et son centre.
            headerLeft={<View style={{ height: CLOSE_SLOT_HEIGHT }} />}
            fitContent
            dismissable={false}
            footer={<Button label={TEXTS.exit} onPress={onExit} loading={exiting} fullWidth />}
            testID={testID}
        >
            <Text size="text-md">{quizMinutes != null ? TEXTS.quiz(quizMinutes) : TEXTS.noQuiz}</Text>
        </Modal>
    )
}
